import React, { useEffect, useState } from 'react';
import { SparklesIcon } from 'lucide-react';
import { useFunnel } from '../../contexts/FunnelContext';
import { formatMoney, getBundle } from '../../utils/pricing';
import { smartSavings } from '../../utils/checkout';
import { track } from '../../utils/analytics';
const m = (n: number) => formatMoney(n, 'en');

/** Smart System Savings — same lights, better official configuration. Never applied without consent. */
export function SmartSavingsNotice() {
  const {
    order,
    replaceOrder
  } = useFunnel();
  const better = smartSavings(order);
  const key = order.map(l => `${l.bundleId}x${l.qty}`).join(',');
  const [dismissed, setDismissed] = useState<string | null>(null);
  useEffect(() => {
    if (better) track('smart_savings', {
      action: 'shown',
      saves: better.saves,
      lights: better.lights
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  if (!better || dismissed === key) return null;
  const label = better.lines.map(l => `${l.qty > 1 ? `${l.qty} × ` : ''}${getBundle(l.bundleId).tagline}`).join(' + ');
  return <div role="status" className="border border-[#C9A54A]/60 bg-[#C9A54A]/10 p-5" data-id="element-152" data-mp="enpycho22bbg">
      <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#E8CF86]" data-id="element-153" data-mp="9owm0ski8qcv">
        <SparklesIcon className="h-4 w-4" aria-hidden data-id="element-154" data-mp="5ocq1sbo3ssb" /> Smart System Savings
      </p>
      <h3 className="mt-2 font-display text-2xl font-semibold uppercase leading-tight text-white" data-id="element-155" data-mp="12dkcr3o0w7xt">
        Get the same {better.lights} lights for {m(better.saves)} less.
      </h3>
      <p className="mt-1 text-sm text-titanium" data-id="element-156" data-mp="so0thwweec2f">Same number of lights. Better system price.</p>
      <div className="mt-4 grid gap-2 sm:grid-cols-[1fr_auto]" data-id="element-157" data-mp="slo2ku8nwrd8">
        <button type="button" onClick={() => replaceOrder(better.lines)} className="inline-flex min-h-[48px] items-center justify-center rounded-md bg-[#E8CF86] px-5 text-center font-display text-[15px] font-semibold uppercase tracking-[0.1em] text-[#0B2037] transition-colors duration-150 hover:bg-[#F2DFA6]" data-id="element-158" data-mp="olxfb0icgtdg">
          Switch to {label} — {m(better.total)}
        </button>
        <button type="button" onClick={() => {
        track('smart_savings', {
          action: 'keep'
        });
        setDismissed(key);
      }} className="min-h-[48px] px-4 text-sm text-titanium transition-colors duration-150 hover:text-white" data-id="element-159" data-mp="3fjs6hyvu2vru">
          Keep my order
        </button>
      </div>
    </div>;
}